"use strict";

var _slicedToArray = require("/codebuild/output/src355747095/src/gravitywell-website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalStorage = void 0;

var React = __importStar(require("react"));

var debug_1 = require("@gravitywelluk/debug");

var logger = debug_1.createDebug("LOCAL_STORAGE");
/**
 * Use local storage hook
 */

var useLocalStorage = function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  var _React$useState = React.useState(function () {
    try {
      // Get from local storage by key
      var item = window.localStorage.getItem(key); // Parse stored json or if none return initialValue

      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      logger.error(error);
      return initialValue;
    }
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      storedValue = _React$useState2[0],
      setStoredValue = _React$useState2[1]; // Return a wrapped version of useState's setter function that persists
  // the new value to localStorage.
  // can pass a callback to avoid useEffect loops if updating an existing value


  var setValue = React.useCallback(function (valueOrCallback) {
    try {
      // standard use case (object)
      if (typeof valueOrCallback === "object") {
        var value = valueOrCallback; // Save state

        setStoredValue(value); // Save to local storage

        window.localStorage.setItem(key, JSON.stringify(value)); // if a callback is passed
      } else {
        // type discrimination doesn't work properly here so need to cast
        var updateStoredValueCallback = valueOrCallback;
        setStoredValue(function (currentValue) {
          var updatedValue = updateStoredValueCallback(currentValue);
          window.localStorage.setItem(key, JSON.stringify(updatedValue));
          return updatedValue;
        });
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      logger.error(error);
    }
  }, [key]);
  return [storedValue, setValue];
};

exports.useLocalStorage = useLocalStorage;